(() => {
    const formulario = document.querySelector(
        '#formulario-adhesion'
    );

    /*
     * Si no estamos en el formulario de adhesión,
     * no ejecutamos el resto del código.
     */
    if (!formulario) {
        return;
    }

    const dniInput = formulario.querySelector(
        '#dni'
    );

    const nombreInput = formulario.querySelector(
        '#nombre_completo'
    );

    const mensaje = formulario.querySelector(
        '#mensaje-dni-adhesion'
    );

    const botonRegistrar = formulario.querySelector(
        '#boton-registrar-adhesion'
    );

    let ultimaConsulta = '';

    /*
     * Mostrar mensajes debajo de la identidad.
     */
    const mostrarMensaje = (
        texto,
        tipo
    ) => {
        mensaje.textContent = texto;

        mensaje.className =
            `mensaje-form ${tipo}`;
    };

    /*
     * Consultar la identidad en PHP.
     */
    const consultarIdentidad = async () => {
        const dni = dniInput.value.replace(
            /\D/g,
            ''
        );

        dniInput.value = dni;

        /*
         * La identidad debe tener exactamente
         * 13 dígitos.
         */
        if (dni.length !== 13) {
            nombreInput.value = '';
            botonRegistrar.disabled = true;

            mostrarMensaje(
                'Ingrese los 13 dígitos de la identidad.',
                'pendiente'
            );

            return;
        }

        /*
         * Evita consultar dos veces la misma DNI.
         */
        if (
            ultimaConsulta === dni
            && nombreInput.value.trim() !== ''
        ) {
            return;
        }

        ultimaConsulta = dni;

        nombreInput.value = '';
        botonRegistrar.disabled = true;

        mostrarMensaje(
            'Consultando identidad...',
            'pendiente'
        );

        try {
            const url =
                `/index.php/adhesiones/buscar-dni?dni=${encodeURIComponent(dni)}`;

            const respuesta = await fetch(
                url,
                {
                    method: 'GET',

                    headers: {
                        Accept: 'application/json'
                    },

                    credentials: 'same-origin'
                }
            );

            if (!respuesta.ok) {
                throw new Error(
                    `Error HTTP ${respuesta.status}`
                );
            }

            const datos =
                await respuesta.json();

            /*
             * La identidad no existe
             * en la tabla personas.
             */
            if (!datos.encontrado) {
                /*
                 * La identidad no existe. Permitimos
                 * escribir el nombre manualmente.
                 */
                nombreInput.value = '';
                nombreInput.readOnly = false;

                nombreInput.placeholder =
                    'Escriba el nombre completo';

                botonRegistrar.disabled = false;

                mostrarMensaje(
                    'La identidad no está registrada. Escriba el nombre manualmente.',
                    'success'
                );

                nombreInput.focus();

                return;
            }

            nombreInput.readOnly = true;

            nombreInput.placeholder =
                'Se completará automáticamente';

            /*
             * Colocar automáticamente
             * el nombre de la persona.
             */
            nombreInput.value =
                datos.nombre || '';

            /*
             * La identidad ya tiene adhesión.
             */
            if (datos.tiene_adhesion) {
                botonRegistrar.disabled = true;

                let texto =
                    datos.mensaje;

                if (datos.fecha) {
                    texto +=
                        ` Registrada el ${datos.fecha}.`;
                }

                mostrarMensaje(
                    texto,
                    'error'
                );

                return;
            }

            /*
             * La persona existe y todavía
             * no tiene adhesión.
             */
            botonRegistrar.disabled = false;

            mostrarMensaje(
                datos.mensaje,
                'success'
            );

        } catch (error) {
            console.error(error);

            ultimaConsulta = '';
            nombreInput.value = '';
            botonRegistrar.disabled = true;

            mostrarMensaje(
                'No se pudo consultar la identidad. Intente nuevamente.',
                'error'
            );
        }
    };

    /*
     * Solo permite números en la identidad.
     */
    dniInput.addEventListener(
        'input',
        () => {
            ultimaConsulta = '';

            dniInput.value =
                dniInput.value.replace(
                    /\D/g,
                    ''
                );

            nombreInput.value = '';
            nombreInput.readOnly = true;

            nombreInput.placeholder =
                'Se completará automáticamente';

            botonRegistrar.disabled = true;

            if (dniInput.value.length === 13) {
                consultarIdentidad();
            } else {
                mostrarMensaje(
                    'Ingrese los 13 dígitos de la identidad.',
                    'pendiente'
                );
            }
        }
    );

    /*
     * También consulta cuando la persona
     * sale del campo de identidad.
     */
    dniInput.addEventListener(
        'blur',
        consultarIdentidad
    );
})();